/* Progressive SDK Rooms embed. Catalog HTML is the source of truth, not an API poll. */
(function () {
  'use strict';
  if (window.__arthausRoomsInstalled) return;
  window.__arthausRoomsInstalled = true;
  var host = 'https://www.taudalpoi.art';
  var dispose;
  function init() {
    if (dispose) dispose();
    var hero = document.querySelector('[data-product-hero]');
    var root = hero && hero.querySelector('[data-hd-scale-scene]');
    var stage = root && root.querySelector('[data-hd-rooms-preview]');
    var image = root && root.querySelector('[data-hd-scale-image]');
    var sheet = root && root.querySelector('[data-hd-scale-sheet]');
    var json = hero && hero.querySelector('[data-hd-pdp-data]');
    if (!stage || !image || !sheet || !json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (_) { return; }
    var emit = window.ahExperienceAnalytics ? window.ahExperienceAnalytics.create({ title: data.title || document.title, product_id: data.productId,
      handle: data.handle, artist: data.artist, entry_point: 'room_preview' }) : function () {};
    var removeBridge;
    root._ahExperienceEmit = emit;
    if (root.style) {
      [['surface','roomBackground'],['ink','roomInk'],['accent','roomAccent'],['border','roomBorderColor']].forEach(function (pair) {
        var value = root.dataset[pair[1]];
        if (/^#[\da-f]{6}$/i.test(value || '')) root.style.setProperty('--ah-preview-' + pair[0], value);
      });
    }
    var frame, timer, observer, dialog, placeholder, overflow, trigger, ready = false, requested = 'rooms', border = !/full.?bleed/i.test(root.dataset.roomBorder || '');
    var lastFinish = root.dataset.framed + ':' + root.querySelector('[data-hd-scale-outer]').getAttribute('fill') + ':' + border;
    var rooms;
    try { rooms = JSON.parse(root.querySelector('[data-hd-room-config]').textContent); } catch (_) { rooms = undefined; }
    var fallback = root.querySelector('[data-hd-scale-fallback]');
    var scaleCaption = root.querySelector('[data-hd-scale-caption]').textContent;
    var choices = [], requestId, status;
    function catalog() {
      var config = hero.querySelector('[data-product-config]');
      var variants;
      try { variants = JSON.parse(config.querySelector('[data-variants-json]').textContent); } catch (_) { return []; }
      var input = config.querySelector('[data-variant-input]');
      var current = variants.find(function (v) { return input && String(v.id) === input.value; });
      if (!current || !data.sizePos || !window.ArthausHDScale) return [];
      return variants.filter(function (v) {
        return v.available && v.options && v.options.every(function (option, i) { return i === data.sizePos - 1 || option === current.options[i]; });
      }).map(function (v) {
        var size = window.ArthausHDScale.parseSize(v.options[data.sizePos - 1]);
        if (!size) return null;
        if (data.landscape && size.w < size.h) { var w = size.w; size.w = size.h; size.h = w; }
        return { id: String(v.id), label: v.options[data.sizePos - 1], widthM: size.w / 100, heightM: size.h / 100,
          finish: (root.dataset.framed === 'true' ? 'Framed' : 'Unframed') + ' / ' + (border ? 'White Border' : 'Full Bleed'),
          framed: root.dataset.framed === 'true', whiteBorder: border, frameColor: root.querySelector('[data-hd-scale-outer]').getAttribute('fill'),
          // v2 variants carry presentment cents, or null when unknown — then no price at all.
          price: v.price == null ? undefined : { amount: v.price / 100, currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD' } };
      }).filter(Boolean);
    }
    function show(mode, isUser) {
      var caption = root.querySelector('[data-hd-scale-caption]');
      if (!fallback.hidden && caption && caption.textContent !== 'Approximate room scale. Frame and border are illustrative.') scaleCaption = caption.textContent;
      requested = mode;
      var changedMode = root.dataset.analyticsMode !== mode;
      root.dataset.analyticsMode = mode;
      if (changedMode && isUser) emit({ action: 'mode_change', properties: { mode: mode } });
      var rooms = mode === 'rooms';
      stage.hidden = !rooms; fallback.hidden = rooms;
      if (status) status.hidden = ready || !rooms;
      var references = root.querySelector('[data-hd-scale-references]');
      if (references) references.style.display = rooms ? 'none' : '';
      if (caption) {
        caption.hidden = rooms;
        if (rooms) caption.textContent = 'Approximate room scale. Frame and border are illustrative.';
        else caption.textContent = scaleCaption;
      }
      root.querySelectorAll('[data-hd-preview-mode]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.hdPreviewMode === (rooms ? 'rooms' : 'scale')));
      });
    }
    function configuration(expanded) {
      var w = Number(sheet.getAttribute('width')), h = Number(sheet.getAttribute('height'));
      var outer = root.querySelector('[data-hd-scale-outer]');
      var caption = root.querySelector('[data-hd-scale-caption]');
      if (caption.textContent !== 'Approximate room scale. Frame and border are illustrative.') scaleCaption = caption.textContent;
      var poster;
      try { poster = new URL(root.dataset.roomPoster || image.getAttribute('href'), window.location.href).href; } catch (_) { return; }
      choices = catalog();
      var input = hero.querySelector('[data-variant-input]');
      var selected = choices.find(function (print) { return input && print.id === input.value; });
      requestId = String(Date.now()) + ':' + Math.random().toString(36).slice(2);
      return { type: 'easel-rooms-config-v1', title: data.title || document.title,
        requestId: requestId, expanded: expanded, prints: choices.length ? choices : undefined, selectedPrintId: selected && selected.id,
        poster: poster, aspect: data.aspect, rooms: rooms,
        theme: { backgroundColor: root.dataset.roomBackground || '#faf8f5', textColor: root.dataset.roomInk || '#2d2d2d', accentColor: root.dataset.roomAccent || '#986c4c', borderColor: root.dataset.roomBorderColor || '#dedbd6' }, print: {
          id: 'current-catalog-selection', label: caption.dataset.cm || w + ' × ' + h + ' cm', widthM: w / 100, heightM: h / 100,
          framed: root.dataset.framed === 'true', whiteBorder: border, frameColor: outer.getAttribute('fill')
        } };
    }
    root._ahRoomsConfig = configuration;
    function send() {
      if (!frame || !frame.contentWindow) return;
      frame.contentWindow.postMessage(configuration(!!dialog), host);
    }
    function receive(event) {
      if (event.origin !== host || !frame || event.source !== frame.contentWindow) return;
      if (event.data && event.data.type === 'easel-rooms-ready-v1') send();
      if (event.data && event.data.type === 'easel-rooms-configured-v1') { clearTimeout(timer); ready = true; show(requested); }
      if (event.data && event.data.type === 'easel-rooms-apply-v1' && dialog && event.data.requestId === requestId) {
        var selected = choices.find(function (print) { return print.id === event.data.printId; });
        if (!selected) return;
        var config = hero.querySelector('[data-product-config]');
        config.dispatchEvent(new CustomEvent('pdp:select-variant', { detail: { id: selected.id } }));
        var input = config.querySelector('[data-variant-input]');
        if (input && input.value === selected.id) { emit({ action: 'apply', properties: { print_id: selected.id, framed: selected.framed } }); dialog.close(); }
      }
    }
    function mount() {
      if (frame) return;
      if (!status) {
        status = document.createElement('div'); status.className = 'hd-rooms-status'; status.setAttribute('role', 'status');
        stage.appendChild(status);
      }
      status.textContent = 'Loading rooms...'; status.hidden = false;
      frame = document.createElement('iframe'); frame.title = 'Artwork room preview';
      frame.src = host + '/embed/rooms'; frame.referrerPolicy = 'origin';
      if (window.ahExperienceAnalytics) removeBridge = window.ahExperienceAnalytics.bridge(frame, emit);
      stage.appendChild(frame);
      timer = setTimeout(function () { if (!ready) {
        emit({ action: 'error', properties: { stage: 'rooms', reason: 'load_timeout' } });
        status.textContent = 'Rooms could not load. ';
        var retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Retry rooms';
        retry.addEventListener('click', function () { if (removeBridge) removeBridge(); frame.remove(); frame = null; mount(); show('rooms'); });
        status.appendChild(retry); show(requested);
      } }, 15000);
      show(requested);
    }
    function variant(event) {
      var opts = event.detail && event.detail.variant && event.detail.variant.options;
      if (opts && data.borderPos > 0) border = !/full.?bleed/i.test(opts[data.borderPos - 1] || '');
      var finish = root.dataset.framed + ':' + root.querySelector('[data-hd-scale-outer]').getAttribute('fill') + ':' + border;
      if (event.detail && event.detail.isUser && finish !== lastFinish) emit({ action: 'finish_change', properties: { variant_id: String(event.detail.variant.id), border: border ? 'white_border' : 'full_bleed', framed: root.dataset.framed === 'true' } });
      lastFinish = finish;
      requestAnimationFrame(send);
    }
    function click(event) {
      var guide = event.target.closest('[data-hd-size-guide-open]');
      if (guide) { openPreview(guide); return; }
      var expand = event.target.closest('[data-hd-preview-expand]');
      if (expand) { openPreview(expand); return; }
      var button = event.target.closest('[data-hd-preview-mode]');
      if (!button) return;
      if (button.dataset.hdPreviewMode === 'rooms') mount();
      show(button.dataset.hdPreviewMode, true);
    }
    function openPreview(button) {
      if (dialog) return;
      trigger = button;
      var panel = root.querySelector('[data-hd-scale-panel]');
      placeholder = document.createComment('Artwork preview'); panel.before(placeholder);
      dialog = document.createElement('dialog'); dialog.className = 'hd-preview-dialog'; dialog.setAttribute('aria-label', 'View Artwork');
      var header = document.createElement('header'); header.className = 'hd-preview-dialog__header';
      var title = document.createElement('span'); title.textContent = data.title || 'View Artwork';
      var close = document.createElement('button'); close.type = 'button'; close.setAttribute('aria-label', 'Close artwork preview');
      close.append(root.querySelector('[data-hd-close-icon]').content.cloneNode(true));
      close.addEventListener('click', function () { dialog.close(); });
      header.append(title, close); dialog.append(header, panel); root.append(dialog);
      var collapsed = panel.classList.contains('max-lg:hidden'); panel.classList.remove('max-lg:hidden');
      overflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', function () {
        emit({ action: 'close', properties: { mode: requested } });
        placeholder.replaceWith(panel); panel.classList.toggle('max-lg:hidden', collapsed);
        dialog.remove(); dialog = null; document.body.style.overflow = overflow;
        send();
        if (trigger.isConnected) trigger.focus();
      }, { once: true });
      dialog.showModal(); close.focus(); mount();
      send();
      emit({ action: 'open', properties: { mode: requested, stage: button.hasAttribute('data-hd-size-guide-open') ? 'size_guide' : 'expanded_preview' } });
    }
    var heroImage = hero.querySelector('[data-gallery-main]');
    var imageButton;
    if (heroImage) {
      var wrapper = document.createElement('div'); wrapper.className = 'hd-preview-hero';
      heroImage.before(wrapper); wrapper.append(heroImage);
      imageButton = document.createElement('button'); imageButton.type = 'button'; imageButton.className = 'hd-preview-hero__button';
      imageButton.append(root.querySelector('[data-hd-expand-icon]').content.cloneNode(true));
      imageButton.append(document.createTextNode('View Artwork')); imageButton.setAttribute('aria-haspopup', 'dialog');
      imageButton.addEventListener('click', function () { openPreview(imageButton); }); wrapper.append(imageButton);
    }
    window.addEventListener('message', receive); hero.addEventListener('pdp:variant-change', variant); hero.addEventListener('click', click);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) { mount(); observer.disconnect(); } }, { rootMargin: '150px' });
      observer.observe(root.querySelector('[data-hd-scale-panel]') || root);
    } else mount();
    dispose = function () { if (dialog) dialog.close(); if (imageButton) { var wrapper = imageButton.parentNode; imageButton.remove(); if (wrapper.isConnected) wrapper.replaceWith(heroImage); } clearTimeout(timer); if (observer) observer.disconnect(); if (removeBridge) removeBridge(); delete root._ahRoomsConfig; delete root._ahExperienceEmit; window.removeEventListener('message', receive); hero.removeEventListener('pdp:variant-change', variant); hero.removeEventListener('click', click); if (frame) frame.remove(); };
  }
  window.addEventListener('pdp:swapped', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
